
export default function RegisterHero() {
  return (
    <section 
      className="relative bg-cover bg-center py-24 px-4"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/110ea128c98bc54ca754a9b27550b54a.jpg')`
      }}
    >
      <div className="max-w-6xl mx-auto text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Join NextZen Soccer Academy
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Start your soccer journey with professional coaching, state-of-the-art facilities, and a supportive community that helps you reach your full potential.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Register Now
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Schedule Tour
          </button>
        </div>
      </div>
    </section>
  );
}
